import React, { ReactNode } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router";
import { RootState } from "@store/store";
import { ROUTES } from "./RouteConstant";
import { useAuthVerification } from "@hooks/useAuthVerification";

interface ProtectedRouteProps {
  children?: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.authenticated,
  );
  // Access authentication state

  const isPortalProtected = useSelector(
    (state: RootState) => state.tokenData.tokenData.portalProtected,
  );

  const { isLoading } = useAuthVerification(true);

  if (isLoading) {
    return (
      <div className="overlay-loader" role="status" aria-label="Loading">
        <div className="spinner" aria-hidden="true"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />; // Redirect to login on unauthenticated access
  }

  if (!isPortalProtected) {
    return <Navigate to={ROUTES.PORTAL_REDIRECTION} replace />;
  }

  return children ? <>{children}</> : <Outlet />; // Render children or Outlet for nested routes
};

export default ProtectedRoute;
